<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="sert"><a class="page" id="pii"></a>The History and Philosophy of Education Series</p>
<p class="sered" style="text-align:center;"><span class="sm">EDITED</span> <span class="sm">BY</span> <span class="sm">RANDALL</span> <span class="sm">CURREN</span> <span class="sm">AND</span> <span class="sm">JONATHAN</span> <span class="sm">ZIMMERMAN</span></p>
<p class="serf" style="text-align:center;"><span class="sm">THE</span> <span class="sm">COLOR</span> <span class="sm">OF</span> <span class="sm">MIND:</span> <span class="sm">WHY</span> <span class="sm">THE</span> <span class="sm">ORIGINS</span> <span class="sm">OF</span> <span class="sm">THE</span> <span class="sm">ACHIEVEMENT</span> <span class="sm">GAP</span> <span class="sm">MATTER</span> <span class="sm">FOR</span> <span class="sm">JUSTICE</span> <i>by Derrick Darby and John L. Rury</i></p>
<p class="serf" style="text-align:center;"><span class="sm">THE</span> <span class="sm">CASE</span> <span class="sm">FOR</span> <span class="sm">CONTENTION:</span> <span class="sm">TEACHING</span> <span class="sm">CONTROVERSIAL</span> <span class="sm">ISSUES</span> <span class="sm">IN</span> <span class="sm">AMERICAN</span> <span class="sm">SCHOOLS</span> <i>by Jonathan Zimmerman and Emily Robertson</i></p>
<p class="serf" style="text-align:center;"><span class="sm">HAVE</span> <span class="sm">A</span> <span class="sm">LITTLE</span> <span class="sm">FAITH:</span> <span class="sm">RELIGION,</span> <span class="sm">DEMOCRACY,</span> <span class="sm">AND</span> <span class="sm">THE</span> <span class="sm">AMERICAN</span> <span class="sm">PUBLIC</span> <span class="sm">SCHOOL</span> <i>by Benjamin Justice and Colin Macleod</i></p>
<p class="serf" style="text-align:center;"><span class="sm">TEACHING</span> <span class="sm">EVOLUTION</span> <span class="sm">IN</span> <span class="sm">A</span> <span class="sm">CREATION</span> <span class="sm">NATION</span> <i>by Adam Laats and Harvey Siegel</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-curren-0003.vue?88a38e3a